<template>
  <!-- Fondo -->
  <transition name="fade">
    <div v-if="visible"
      class="fixed inset-0    bg-black/30  flex items-center justify-center z-50">

      <!-- Modal -->
      <div class="bg-white rounded-xl shadow-2xl w-full max-w-lg p-6   transform transition-all scale-100 border border-gray-200">
        <div class="flex justify-between">
            <span class="text-xs text-indigo-500 font-mono bg-indigo-50 px-3 py-1 rounded-full shadow-sm">&#60;ModalTiposModificacion&#62;</span>
        </div>
        <!-- Header -->
        <div class="relative border-b pb-4 mb-6 flex items-center justify-center">
 <!-- Título sección -->
  
 
          <!-- Título centrado -->
          <h2 class="text-xl font-semibold text-gray-800 text-center w-full">
            Modificación de Presupuesto
          </h2>

          <!-- Botón cerrar -->
          <button @click="cerrar"
            class="absolute right-0 text-gray-400 hover:text-gray-600 transition text-2xl leading-none">
            ✕
          </button>
        </div>

        <!-- Subtítulo: centro y cuenta -->
        <div class="mb-4">
          <div class="text-base font-medium text-gray-700">
            {{ datos.nomcentro }}
            <span class="text-gray-400 mx-1">/</span>
            {{ datos.nomcta }}
          </div>
        </div>

        <!-- Contenedor interno -->
        <div class="bg-gray-50 p-5 rounded-xl border border-gray-200 space-y-5">

          <!-- Resumen del presupuesto -->
          <div class="text-base font-semibold text-gray-700">
            Presupuesto {{ datos.nommes }}:
            <span class="text-blue-600 font-bold">
              ${{ $formatoMiles(monto_mensual_ingreso) }}
            </span>
          </div>

       

          <!-- Select -->
          <div>
            <label class="block text-sm text-gray-700 font-medium mb-1">
              Acción a realizar
            </label>

            <select class="w-full border border-gray-300 rounded-lg px-4 py-3 text-base 
               shadow-sm focus:ring-2 focus:ring-blue-400 focus:border-blue-500 transition"
              v-model="opcionSeleccionada">
              <option value="">Seleccione una acción</option>

              <option value="1-false">➕ Sumar</option>

              <option value="2-false" :disabled="monto_mensual_ingreso <= 0">
                ➖ Restar
              </option>

              <option value="1-true">➕🔁 Sumar extrayendo de otras cuentas</option>

              <option value="2-true" :disabled="monto_mensual_ingreso <= 0">
                ➖🔁 Restar y reasignar a otras cuentas
              </option>
            </select>
          </div>

          <!-- Input monto -->
          <div>
            <label class="block text-sm text-gray-700 font-medium mb-1">
              Monto
            </label>

            <input type="text" placeholder="Ingrese el monto" @blur="handleBlurMonto" v-model="monto_modificacion"
              class="border rounded-lg px-4 py-3 w-full bg-white shadow-sm text-base 
               text-gray-800 focus:ring-2 focus:ring-blue-300 outline-none transition" :class="{
                'border-gray-300': !error_monto,
                'border-red-500': error_monto
              }" />

            <!-- Errores -->
            <p v-if="error_monto" class="text-red-500 text-xs mt-1 flex items-center gap-2">
              ❌ Debe ingresar un monto.
            </p>

            <p v-if="error_monto_invalido" class="text-red-500 text-xs mt-1 flex items-center gap-2">
              ❌ Monto no válido.
            </p>
          </div>
   <!-- Vista previa del cálculo -->
          <div v-if="signo_operacion" class="text-gray-600 text-sm bg-white px-4 py-2 rounded-md border">
            <span class="font-medium">
              ${{ $formatoMiles(monto_mensual_ingreso) }}
            </span>
            {{ signo_operacion }}
            <span class="font-medium">
              ${{ $formatoMiles(monto_modificacion) }}
            </span>
            =
            <span class="font-bold text-blue-700">
              ${{ $formatoMiles(total_tentativo) }}
            </span>
          </div>
          <!-- Botón confirmar -->
          <button @click="confirmar()" class="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold 
             py-3 rounded-lg shadow transition text-base">
            Confirmar
          </button>
        </div>

        <!-- Footer -->
        <div class="flex justify-end mt-8 pt-4 border-t">
          <button @click="cerrar" class="px-5 py-2 rounded-lg bg-gray-100 hover:bg-gray-200 
             text-gray-700 font-medium transition">
            Cerrar
          </button>
        </div>

        <!-- Debug si lo necesitas -->
        <!-- {{ datos }} -->

      </div>

    </div>
  </transition>
</template>


<script>

export default {
  name: "ModalIngresoMes",
  emits: ['get_monto_mensual_presupuesto', 'get_tipo_modif'],
  props: {
    visible: {
      type: Boolean,
      required: true,
    },


    datos: {
      type: Object
    },

  },
  computed: {

  },
  watch: {
    visible: function (v) {
      console.log('visible', v);
      if (v) {
        this.opcionSeleccionada = '';
        this.monto_modificacion = '';
        this.signo_operacion = '';
        this.total_tentativo = 0;
      }
    },
    datos: function (v) {



      this.nommes = v.nommes;
      this.nomcentro = v.nomcentro;
      this.nomcta = v.nomcta
      this.monto_mensual_ingreso = v.monto_mensual_ingreso


    },
    opcionSeleccionada: function (v) {

      if (!v) return;
      this.recalcular()

    },
    monto_modificacion: function (v) {
      this.monto_modificacion = (!isNaN(v) && v) || '';
      this.recalcular()
    }

  },
  methods: {
    cerrar() {
      this.$emit("update:visible", false);
    },



    confirmar() {

      if (!this.opcionSeleccionada) return false;
      if (this.total_tentativo < 0) { this.error_monto_invalido = true; return false }


      const [tipo, reasignar] = this.opcionSeleccionada.split("-");

      const monto_modificacion = parseFloat(this.monto_modificacion)


      if (!monto_modificacion) {
        this.error_monto = true;
        return false;
      }

      if (tipo == 2 && this.monto_mensual_ingreso < monto_modificacion) {
        return false;
      }

      if (tipo == 2 && this.monto_mensual_ingreso <= 0) {
        return false;
      }


      console.log(tipo, monto_modificacion, this.monto_mensual_ingreso)
      this.$emit("get_tipo_modif", { 'accion_id': tipo, 'reasignar': reasignar, 'monto_modif': monto_modificacion });
      this.cerrar();
      this.monto_modificacion = ''
      return true;



    },
    recalcular() {
      let monto = parseFloat(this.monto_modificacion);
      let base = parseFloat(this.monto_mensual_ingreso);

      if (!this.opcionSeleccionada) {
        return false;
      }
      if (monto <= 0) {
        return false;
      }

      this.error_monto_invalido = false;

      let v = this.opcionSeleccionada;
      const [tipo] = v.split("-");
      //const  monto_modificacion = parseFloat(this.monto_modificacion) 



      //   NaN o valores vacíos/ inválidos

      monto = Number(monto) || 0;
      base = Number(base) || 0;


      const esSuma = tipo == 1;
      const operador = esSuma ? 1 : -1;


      if (monto > 0) {
        this.total_tentativo = base + operador * monto;
        // 100 + (1 * 20) → 120
        // 100 + (-1 * 20) → 80
      }
      if (this.total_tentativo < 0) {
        this.error_monto_invalido = true;

      }

      this.signo_operacion = esSuma ? '+' : '-';
    }
  },
  data() {
    return {
      monto_mensual_ingreso: 0,
      glosa: '',
      rendicion_id: 0,

      mes: 0,
      nomcentro: '',
      nomcta: '',
      nommes: ' ',

      monto_modificacion: '',
      error_monto: '',
      error_monto_invalido: '',
      opcionSeleccionada: '',
      signo_operacion: '',
      total_tentativo: 0
    }
  },
  mounted() {
    console.log('montar')
    this.monto_modificacion = ''

  }
};
</script>

<style scoped></style>
